export class BaseError extends Error {
  private reason: string;
  private code?: string;

  constructor(reason: string, code?: string) {
    super(reason);
    this.reason = reason;
    this.code = code;
  }

  public getReason() {
    return this.reason;
  }

  public getCode() {
    return this.code;
  }
}
